import React from 'react'
import { MdHealthAndSafety } from "react-icons/md";
import { MdRealEstateAgent } from "react-icons/md";
import { SiMoneygram } from "react-icons/si";
import { MdPrecisionManufacturing } from "react-icons/md";
import { FaTruckFast } from "react-icons/fa6";
import { HiShoppingBag } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';

const Ourservice = () => {

    const navigate = useNavigate()

    const handleHealthCare = ()=>{
        sessionStorage.setItem('selectedService', 'Health Care');
        sessionStorage.setItem('serviceid', 1);
        navigate('/selectsubserives');
    }

    const handleRealEstate = ()=>{
        sessionStorage.setItem('selectedService', 'Real Estate');
        sessionStorage.setItem('serviceid', 5);
        navigate('/selectrealEaste');
    }

    const handleFinancialService= ()=>{
        sessionStorage.setItem('selectedService', 'Financial Service');
        sessionStorage.setItem('serviceid', 3);
        navigate('/financialService');
    }
    const handleManufacturing= ()=>{
        sessionStorage.setItem('selectedService', 'Manufacturing');
        sessionStorage.setItem('serviceid', 4);
        navigate('/manufacturing');
    }

    const handleMovers= ()=>{
        sessionStorage.setItem('selectedService', 'Movers');
        sessionStorage.setItem('serviceid', 2);
        navigate('/movers');
    }

    const handleEcommers = ()=>{
        sessionStorage.setItem('selectedService', 'E-Commerce');
    sessionStorage.setItem('serviceid', 6);
    navigate('/ecommers');
    }

  return (
    <div  id="service">
      <section class="we-offer-area text-center bg-gray">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="site-heading text-center">
                        <h2>Our <span>Services</span></h2>
                        <h4>Blaccdot Delivers Results, Simplified in your space</h4>
                    </div>
                </div>
            </div>
           
                <div class="row our-offer-items less-carousel">
                    
                    <div onClick={handleHealthCare} class="col-md-4 col-sm-6 equal-height" style={{cursor:'pointer'}}>
                        <div class="item">
                        <i className="fas fa-pen-fancy">
                        <MdHealthAndSafety size={50} style={{marginBottom:'10px'}}/>
                        </i>
                            <h4>Health Care</h4>
                            <p>
                            Blaccdot's streamlines qualified healthcare leads for providers and manufacturers.
                            </p>
                        </div>
                    </div>

                    <div onClick={handleRealEstate} class="col-md-4 col-sm-6 equal-height" style={{cursor:'pointer'}}>
                        <div class="item">
                              <i className="fas fa-pen-fancy">
                                <MdRealEstateAgent size={50} style={{marginBottom:'10px'}}/>
                               
                                </i>
                            <h4>Real Estate</h4>
                            <p>
                            Capture and nurture real estate leads with Blaccdot's automation. 
                            </p>
                        </div>
                    </div>
                    <div onClick={handleFinancialService} class="col-md-4 col-sm-6 equal-height" style={{cursor:'pointer'}}>
                        <div class="item">
                            <i className="fas fa-pen-fancy">
                              <SiMoneygram size={50} style={{marginBottom:'10px'}}/>
                            </i>
                            <h4>Financial Service</h4>
                            <p>
                             Blaccdot's AI qualifies and routes financial services lead efficiently. 
                            </p>
                        </div>
                    </div>
               
                    <div onClick={handleManufacturing} class="col-md-4 col-sm-6 equal-height" style={{cursor:'pointer'}}>
                        <div class="item">
                          <i className="fas fa-pen-fancy">
                           <MdPrecisionManufacturing size={50} style={{marginBottom:'10px'}}/>
                         </i>
                            <h4>Manufacturing</h4>
                            <p>
                            Blaccdot's consolidates manufacturing leads from multiple sources into one. 
                            </p>
                        </div>
                    </div>
                    <div onClick={handleMovers} class="col-md-4 col-sm-6 equal-height" style={{cursor:'pointer'}}>
                        <div class="item">
                            <i className="fas fa-pen-fancy">
                              <FaTruckFast size={50} style={{marginBottom:'10px'}}/>
                            </i>
                            <h4>Movers</h4>
                            <p>Accelerate your move by connecting with trusted packers and movers through Blaccdot</p>
                        </div>
                    </div>
                    <div onClick={handleEcommers} class="col-md-4 col-sm-6 equal-height" style={{cursor:'pointer'}}>
                        <div class="item">
                        <i className="fas fa-pen-fancy">
                          <HiShoppingBag size={50} style={{marginBottom:'10px'}}/>
                        </i>
                            <h4>E-Commerce</h4>
                            <p>
                            Maximize e-commerce revenue with Blaccdot's lead capture and nurturing.                             </p>
                        </div>
                    </div>
                </div>
        </div>
    </section>
    </div>
  )
}

export default Ourservice
